export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const scrollToPosition = (val) => {
  window.scrollTo({
    top: val,
    behavior: "smooth",
  });
};
